import apiService from "./BaseApi";
import store from "@/store/index";

const ENDPOINT_READINGS_BY_MODEM = "readings/byModem";

const currentUserPayload = () => ({
  currentUserId: store.state.currentUser?.uid,
});

const ReadingsService = {
  byModem: async (modemId) =>
    apiService.post(ENDPOINT_READINGS_BY_MODEM, {
      ...currentUserPayload(),
      modemId,
    }),

  telemetryByModem: async (modemId) =>
    apiService.post("readings/telemetry/byModem", {
      ...currentUserPayload(),
      modemId,
    }),
};

export default ReadingsService;
